// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2u9KX","image":"styles_image__2gA7U","description":"styles_description__2CDf7"};